import { useState } from "react";
import { BottomNav } from "./BottomNav/BottomNav";
import { ParcelList } from "../parcelList/ParcelList";
import FarmFormTab from "../form/FarmForm/FarmFormTab";

const tabs = [
  { name: "Betrieb", content: <FarmFormTab onSave={() => console.log()} /> },
  { name: "Parzellen", content: <ParcelList /> },

];

const TabComponent = () => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index: number) => setActiveTab(index);

  return (
    <>
      <div className="w-full max-w-[1600px] mx-auto p-2 md:p-4 transition-all duration-300 ease-in-out mb-14 !min-w-80">
        <div className="w-full bg-white rounded-2xl shadow-lg overflow-hidden min-h-[90vh] flex flex-col justify-between">
          {/* Tabs Header */}
          <div className="flex bg-gray-100 rounded-t-2xl">
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`px-5 py-3 text-base font-medium rounded-t-2xl transition-all duration-300
                  ${
                    activeTab === index
                      ? "bg-[#2F4F2F] text-white shadow-sm"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                onClick={() => handleTabClick(index)}
              >
                {tab.name}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="bg-gray-50 rounded-b-2xl p-2 flex-1 shadow-inner min-h-[500px]">
            {tabs[activeTab].content}
          </div>
        </div>

      </div>
      {/* Bottom Navigation */}
      <BottomNav />
    </>
  );
};

export default TabComponent;
